export const CREATIVE_TEMPLATE_SCHEMA_VERSION = "1.0";
export const CREATIVE_TEMPLATE_MAX_NODES = 50;
export const CREATIVE_TEMPLATE_DEFAULT_ARTBOARD_SIZE = 2048;
export const CREATIVE_TEMPLATE_DEFAULT_ARTBOARD_ID = "primary";
export const CREATIVE_TEMPLATE_CAROUSEL_CREATE_ENABLED = true;
export const CREATIVE_TEMPLATE_CONTINUOUS_CAROUSEL_ENABLED = true;
export const CREATIVE_TEMPLATE_SLIDE_MIN = 2;
export const CREATIVE_TEMPLATE_SLIDE_MAX = 10;
export const CREATIVE_TEMPLATE_CONTINUOUS_SLIDE_MIN = 2;
export const CREATIVE_TEMPLATE_CONTINUOUS_SLIDE_MAX = 10;
export const CREATIVE_TEMPLATE_STRIP_MAX_EDGE = 20480;
export const CREATIVE_TEMPLATE_STRIP_MAX_PIXELS = 44e6;
export const CREATIVE_TEMPLATE_LAYOUT_KIND = {
  SINGLE: "single",
  CAROUSEL: "carousel",
  CONTINUOUS_CAROUSEL: "continuousCarousel",
};
